import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {Component, inject, OnInit} from '@angular/core';
import {FlexLayoutModule} from "@angular/flex-layout";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatOption} from "@angular/material/autocomplete";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatSelect} from "@angular/material/select";
import {ActivatedRoute} from "@angular/router";
import {AdminContextService} from "@app/security/admin-context.service";
import {BillingDetailsUploadComponent} from "@features/leasing/billing-details-upload/billing-details-upload.component";
import {LeaseUploadComponent} from "@features/leasing/lease-upload/lease-upload.component";
import {Lease} from "@features/leasing/lease-upload/lease-upload.model";
import {LeaseUploadService} from "@features/leasing/lease-upload/lease-upload.service";
import {LoadingService} from "@ui-kit/utils/service/loading.service";
import {displayShortDate} from "@ui-kit/utils/static/date-format-utils";
import {PageHeaderComponent} from "@ui-webkit/components/page-header/page-header.component";

@Component({
  selector: 'app-leasing-upload',
  standalone: true,
  imports: [
    MatProgressBarModule,
    LeaseUploadComponent,
    PageHeaderComponent,
    AsyncPipe,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    NgForOf,
    NgIf,
    BillingDetailsUploadComponent,
    ReactiveFormsModule,
    FlexLayoutModule,
  ],
  templateUrl: './leasing-upload.component.html',
  styleUrl: './leasing-upload.component.scss'
})
export class LeasingUploadComponent implements OnInit {
  private _loader = inject(LoadingService);
  protected loading$ = this._loader.loading$;
  protected readonly displayShortDate = displayShortDate;

  parentLeases: { retailerCompanyName: string, uuid: string }[] = [];
  selectedParentLease = new FormControl<Lease | null>(null);

  uploadType: "lease" | "billing" = "lease";

  constructor(private leaseUploadService: LeaseUploadService,
              private route: ActivatedRoute,) {
    const path = this.route.snapshot.url[0].path;
    if (path == 'lease-upload') this.uploadType = "lease";
    if (path == 'billing-upload') this.uploadType = "billing";
  }

  ngOnInit() {
    this.loadHeadLeases();
  }

  loadHeadLeases() {
    this.leaseUploadService.getHeadLeases().subscribe({
      next: data => {
        this.parentLeases = data.content;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  get parentLease() {
    if (this.selectedParentLease) return this.selectedParentLease.value;
    return null;
  }
}
